<template>
  <div :class="$style.root" :style="rootStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    aside: {
      type: Number,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rootStyle () {
      if (this.readOnly) {
        return {
          'margin-left': '60px',
          'margin-right': '60px',
        }
      }
      return {
        'margin-left': `${this.aside}px`,
        'margin-right': '120px',
      }
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply flex;
  @apply flex-wrap;
  @apply justify-center;
}
</style>
